export default {
    GET_CONSUMER_DATA: "GET_CONSUMER_DATA",    
    SET_CONSUMER_DATA: "SET_CONSUMER_DATA" 
};